module.exports = "/_next/static/images/WashingtonLogo-50e956cc5237226755833e8014818ebd.png";